import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import type { Dayjs } from 'dayjs';
import { referenceOf } from '@/stores/useReferenceOptions';

/**
 * Historique des statuts d'une feuille d'heures (GET / POST /time_sheet_status_histories). L'employé poste
 * {timeSheet, timeSheetStatus: Soumise} (IRI) : l'API passe ensuite la feuille en attente du manager ou du Dirigeant.
 * Le Dirigeant de la société poste Validée, ou Refusée avec un motif (comment, obligatoire) : la feuille repart alors en
 * brouillon.
 * La ligne Soumise donne la date de soumission. Filtres : timeSheet (ou liste d'IRI), timeSheetStatus.
 */
export default class TimeSheetStatusHistoryModel extends AbstractApiModel {
  protected _path = '/time_sheet_status_histories/{?id}';

  declare _tsFilters: { timeSheet?: string | string[]; timeSheetStatus?: id };

  @doc.date declare createdAt: Dayjs;
  /** Auteur de l'étape (URN $:teiji:user:N) : la « signature » */
  @doc.string declare createdBy: string;
  /** Motif d'un refus */
  @doc.string declare comment: string;

  /** timeSheet arrive imbriquée ({@id…}) ou en IRI */
  get timeSheetId(): number {
    const timeSheet = this.get<unknown, unknown>('timeSheet', null);
    const iri = typeof timeSheet === 'string' ? timeSheet : ((timeSheet as { '@id'?: string } | null)?.['@id'] ?? '');
    return Number(iri.split('/').pop()) || 0;
  }

  get timeSheetStatusLabel(): string {
    return referenceOf('timeSheetStatuses', this.get<unknown, unknown>('timeSheetStatus', null))?.label ?? '';
  }

  /** timeSheetStatus arrive en {id, reference, label} */
  get timeSheetStatusReference(): string {
    return referenceOf('timeSheetStatuses', this.get<unknown, unknown>('timeSheetStatus', null))?.reference ?? '';
  }
}
